import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
} from "react";
import { useNavigate } from "react-router-dom";

/* -------------------- CATEGORY LIST -------------------- */

const CategoryList = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // Simulación de datos (para el test)
      setCategories([
        { _id: 1, cImage: 'placeholder.jpg', cName: 'Categoría 1' },
        { _id: 2, cImage: 'placeholder.jpg', cName: 'Categoría 2' },
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="my-4">
      <hr />
      <div className="py-1 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {categories && categories.length > 0 ? (
          categories.map((item, index) => (
            <Fragment key={index}>
              <div
                onClick={() => navigate(`/products/category/${item._id}`)}
                className="col-span-1 m-2 flex flex-col items-center justify-center space-y-2 cursor-pointer"
              >
                <img
                  src={`https://via.placeholder.com/100?text=${item.cName}`}
                  alt="pic"
                />
                <div className="font-medium">{item.cName}</div>
              </div>
            </Fragment>
          ))
        ) : (
          <div className="text-xl text-center my-4">No Category</div>
        )}
      </div>
    </div>
  );
};

/* -------------------- UNIFIED SEARCH & FILTER -------------------- */

const UnifiedSearchFilter = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const applyFilters = () => {
    console.log("Aplicando filtros:", {
      title,
      description,
      minPrice,
      maxPrice,
    });

    alert("Filtros aplicados (simulado)");
  };

  return (
    <div className="my-4 p-4 border rounded bg-white">
      <h2 className="font-semibold mb-3 text-lg">Search & Filter</h2>

      {/* Title */}
      <input
        type="text"
        className="w-full border p-2 mb-3"
        placeholder="Search by title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      {/* Description */}
      <input
        type="text"
        className="w-full border p-2 mb-3"
        placeholder="Search by description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      {/* Prices */}
      <div className="flex gap-3 mb-3">
        <input
          type="number"
          className="w-1/2 border p-2"
          placeholder="Min price"
          value={minPrice}
          onChange={(e) => setMinPrice(e.target.value)}
        />
        <input
          type="number"
          className="w-1/2 border p-2"
          placeholder="Max price"
          value={maxPrice}
          onChange={(e) => setMaxPrice(e.target.value)}
        />
      </div>

      {/* Button */}
      <button
        className="w-full bg-gray-800 text-white p-3 rounded hover:bg-black transition"
        onClick={applyFilters}
      >
        Apply Search & Filters
      </button>
    </div>
  );
};

/* -------------------- FINAL COMPONENT -------------------- */

const ProductCategoryDropdown = () => {
  return (
    <Fragment>
      <CategoryList />
      <UnifiedSearchFilter />
    </Fragment>
  );
};

export default ProductCategoryDropdown;
